const common = {
  en: {
    siteTitle: "Discover Global Network Travel Guides",
    close: "Close",
    closeModal: "Close Modal",
    searchDefault: "Find a Destination",
    travelGuides: "Travel Guides",
    categories: {
      all: "All",
      eat: "Eat",
      shop: "Shop",
      stay: "Stay",
      attractions: "Attractions",
      transportation: "Transportation",
    },
    mustSeeAttractions: "Must-see attractions all over town",
    acceptanceLine:
      "Use your card here and anywhere you see these in-network logos:",
    recentGoogleReviews: "Recent Google Reviews",
    seeGoogleReviews: "See XX Google Reviews",
    trendingDestinations: "Trending Destinations",
    yourResults: "Your Results",
    noResults: "No results for ",
    noResultsCopy:
      "Only cities with Travel Guides and countries appear here. To find recommended merchants, check out a Travel Guide.",
    countries: "Destination Information",
    globalAcceptance: "Global Acceptance",
    guide: "Guide",
    techDiff: "Looks like something went wrong.",
    map: "Map",
    list: "List",
    acceptanceMap: "Acceptance Map",
    read: "Read",
    less: "less",
    more: "more",
    looksLike: "Looks like we don't have any",
    inThisArea: " in this area. Try moving the map to find more.",
    recommendedPlaces: "recommended places",
    recommendedPlacesTo: "recommended places to",
    recommended: "recommended",
    hideMe: "Hide Me",
    showMe: "Show Me",
    okay: "Okay",
    letsGo: "Let's Go",
    noThanks: "No Thanks",
    showingAllRecommended: "Showing all recommended places",
    showingRecommendedPlacesTo: "Showing recommended places to",
    showingRecommended: "Showing recommended",
    acceptanceIn: "Acceptance In",
    exploreTheGlobalMap: "Explore the Global Map",
    search: "Search",
    techDiffMessage:
      "We ran into some technical difficulties processing your request. Please try again later.",
  },
  es: {
    siteTitle: "CityGuides MVP1",
    close: "Close",
    closeModal: "Close Modal",
    searchDefault: "Find a Destination",
  },
};

export default common;
